var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Switch as MuiSwitch } from "@mui/material";
import { COLORS, HALO } from "../../../../constants";
var switchSxProps = {
    py: "9px",
    height: "32px",
    "&.MuiSwitch-root .MuiSwitch-track": {
        backgroundColor: COLORS.BLACK_OVERLAY_PRESSED,
    },
    ".MuiSwitch-thumb": {
        boxShadow: "none",
        border: "1px solid ".concat(COLORS.P_OUTLINE),
    },
    "input:focus-visible ~ .MuiTouchRipple-root": {
        span: {
            background: "none",
        },
    },
    "input:focus-visible ~ .MuiSwitch-thumb": {
        boxShadow: HALO,
    },
    ".MuiSwitch-track": {
        opacity: "1 !important",
    },
    ".MuiSwitch-switchBase": {
        p: 1.5,
        "&.Mui-disabled": {
            color: COLORS.P_DISABLED,
            "&.Mui-checked": {
                color: COLORS.PERIWINKLE,
            },
        },
        "&.Mui-checked + .MuiSwitch-track": {
            backgroundColor: COLORS.OVERLAY_PRESSED,
        },
        "&:hover": {
            bgcolor: COLORS.BLACK_OVERLAY_HOVER,
        },
        "&:active": {
            bgcolor: COLORS.BLACK_OVERLAY_PRESSED,
        },
    },
    ".Mui-checked": {
        ".MuiSwitch-thumb": {
            border: "none",
        },
        color: "primary.main",
        "&:active": {
            bgcolor: COLORS.OVERLAY_PRESSED,
        },
        "&:hover": {
            bgcolor: COLORS.OVERLAY_HOVER,
        },
    },
};
var Switch = function (props) {
    return _jsx(MuiSwitch, __assign({ sx: switchSxProps, color: "default" }, props));
};
export default Switch;
